// src/theme/tokens/srs.js
// Faz 1 · Spaced Repetition System (flashcard) semantic tokens.
// Anki/SuperMemo modeli: Again, Hard, Good, Easy, New, Mastered.
// Mevcut flashcardAccent / srsAccent token'lari korunur.

const srsTokens = {
  // ===== AGAIN (kart hatirlanmadi, 1-2 dk sonra tekrar) =====
  'srs.again.bg':       { default: 'rose.50',  _dark: 'rose.900' },
  'srs.again.bgSolid':  { default: 'rose.500', _dark: 'rose.400' },
  'srs.again.bgHover':  { default: 'rose.600', _dark: 'rose.500' },
  'srs.again.text':     { default: 'rose.700', _dark: 'rose.200' },
  'srs.again.textOnSolid': { default: 'white', _dark: 'rose.950' },
  'srs.again.border':   { default: 'rose.300', _dark: 'rose.700' },

  // ===== HARD (zor hatirlandi, kisa interval) =====
  'srs.hard.bg':       { default: 'amber.50',  _dark: 'amber.900' },
  'srs.hard.bgSolid':  { default: 'amber.500', _dark: 'amber.400' },
  'srs.hard.bgHover':  { default: 'amber.600', _dark: 'amber.500' },
  'srs.hard.text':     { default: 'amber.700', _dark: 'amber.200' },
  'srs.hard.textOnSolid': { default: 'white',  _dark: 'amber.950' },
  'srs.hard.border':   { default: 'amber.300', _dark: 'amber.700' },

  // ===== GOOD (normal hatirlandi, varsayilan interval) =====
  'srs.good.bg':       { default: 'emerald.50',  _dark: 'emerald.900' },
  'srs.good.bgSolid':  { default: 'emerald.500', _dark: 'emerald.400' },
  'srs.good.bgHover':  { default: 'emerald.600', _dark: 'emerald.500' },
  'srs.good.text':     { default: 'emerald.700', _dark: 'emerald.200' },
  'srs.good.textOnSolid': { default: 'white',    _dark: 'emerald.950' },
  'srs.good.border':   { default: 'emerald.300', _dark: 'emerald.700' },

  // ===== EASY (kolay hatirlandi, uzun interval) =====
  'srs.easy.bg':       { default: 'brand.50',  _dark: 'brand.900' },
  'srs.easy.bgSolid':  { default: 'brand.500', _dark: 'brand.400' },
  'srs.easy.bgHover':  { default: 'brand.600', _dark: 'brand.500' },
  'srs.easy.text':     { default: 'brand.700', _dark: 'brand.200' },
  'srs.easy.textOnSolid': { default: 'white',  _dark: 'brand.950' },
  'srs.easy.border':   { default: 'brand.300', _dark: 'brand.700' },

  // ===== NEW (henuz ogrenilmemis kart) =====
  'srs.new.bg':       { default: 'indigo.50',  _dark: 'indigo.900' },
  'srs.new.bgSolid':  { default: 'indigo.500', _dark: 'indigo.400' },
  'srs.new.text':     { default: 'indigo.700', _dark: 'indigo.200' },
  'srs.new.border':   { default: 'indigo.300', _dark: 'indigo.700' },
  'srs.new.badge':    { default: 'indigo.500', _dark: 'indigo.300' },

  // ===== LEARNING (ogrenme asamasinda) =====
  'srs.learning.bg':       { default: 'amber.50',  _dark: 'amber.900' },
  'srs.learning.bgSolid':  { default: 'amber.400', _dark: 'amber.300' },
  'srs.learning.text':     { default: 'amber.700', _dark: 'amber.200' },
  'srs.learning.border':   { default: 'amber.300', _dark: 'amber.700' },

  // ===== REVIEW (tekrar zamani gelmis kart) =====
  'srs.review.bg':       { default: 'teal.50',  _dark: 'teal.900' },
  'srs.review.bgSolid':  { default: 'teal.500', _dark: 'teal.400' },
  'srs.review.text':     { default: 'teal.700', _dark: 'teal.200' },
  'srs.review.border':   { default: 'teal.300', _dark: 'teal.700' },

  // ===== MASTERED (uzun interval, %95+ basari) =====
  'srs.mastered.bg':       { default: 'slate.50',  _dark: 'slate.800' },
  'srs.mastered.bgSolid':  { default: 'slate.400', _dark: 'slate.500' },
  'srs.mastered.text':     { default: 'slate.700', _dark: 'slate.200' },
  'srs.mastered.border':   { default: 'slate.200', _dark: 'slate.700' },
  'srs.mastered.badge':    { default: 'slate.500', _dark: 'slate.400' },

  // ===== SUSPENDED (kullanici tarafindan duraklatilmis) =====
  // 'srs.suspended.*' tokenlari kaldirildi (sifir kullanim · suspend UI henuz uretilmedi).
  // again/hard/good/easy/new/learning/review/mastered tokenlari aktif kullanimda.
};

export default srsTokens;
